angular.module('rjmNg.services').factory('timezoneService', [
	"$http"
	"$rootScope"
	"$url"
	(
		$http
		$rootScope
		$url
	) ->
		timezoneService = {}

		timezoneService.fetch = () ->
			$http.get($url("/timezone"))

		timezoneService
	]
)
